import { render } from "./S530_LieferantFehlerhafteRechnungen.vue?vue&type=template&id=9ef35aa6&scoped=true&ts=true"
import script from "./S530_LieferantFehlerhafteRechnungen.vue?vue&type=script&lang=ts"
export * from "./S530_LieferantFehlerhafteRechnungen.vue?vue&type=script&lang=ts"

import "./S530_LieferantFehlerhafteRechnungen.vue?vue&type=style&index=0&id=9ef35aa6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ef35aa6"]])

export default __exports__